import { CurrentConversationState } from "utilities/atoms/conversations/current-conversation/conversation-atom.reducer";
import {
    UseConversationHookOptions,
    useConversationState,
} from "./use-conversation-state.hook";
import {
    useConversationActions,
    UseConversationActionsHookResult,
} from "./use-conversation-actions.hook";

export interface UseConversationHookResult
    extends CurrentConversationState,
        UseConversationActionsHookResult {}

/**
 * Custom hook to manage conversations state.
 * Provides methods to create a new conversation and send messages.
 * Note: only use this hook if you need both state and actions.
 */
export function useConversation({
    onConversationLoaded,
}: UseConversationHookOptions = {}): UseConversationHookResult {
    const state = useConversationState({ onConversationLoaded });
    const actions = useConversationActions();

    return {
        ...state,
        ...actions,
    };
}
